<mat-form-field>
    <mat-label>{{ 'reservation-choosen-category' | translate }}</mat-label>
    <mat-select matNativeControl [(ngModel)]="choosenCategory">
        <mat-option *ngFor="let category of reservationCategories" [value]="category">
            {{ category.fullName }} {{ category.categoryTag }}
        </mat-option>
    </mat-select>
</mat-form-field>
